export default "__VITE_ASSET__3DafeLyE__"